export default __webpack_public_path__ + "static/media/duck.ed546bb5.svg";